import { Component, OnInit, Input, TemplateRef, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { FormGroup, AbstractControl } from '@angular/forms';

@Component({
    selector: 'shared-forms-submit',
    templateUrl: './forms-submit.shared.component.html',
    styleUrls: ['./forms-submit.shared.component.scss']
})
export class FormsSubmitComponent implements OnInit {
    @Input() public parentForm!: FormGroup;
    @Input() public formName: string = null;
    @Input() public tabindex: number = 0;
    @Input() public left!: TemplateRef<any>;
    @Input() public right!: TemplateRef<any>;
    @Input() public badgeLeft: string | number = null;
    @Input() public badgeRight: string | number = null;
    @Input() public badgePosition: 'tl' | 'tr' | 'bl' | 'br' = null;
    @Input() public badgeSize: OLO.Components.BUTTON_SIZE;
    @Input() public size: OLO.Components.BUTTON_SIZE = 'lg';
    @Input() public inverted: boolean = false;
    @Input() public feel: OLO.Components.BUTTON_FEEL | OLO.Components.BUTTON_CIRCLE_FEEL = 'primary';
    @Input() public iconLeft: string = null;
    @Input() public iconRight: string = null;
    @Input() public title: string = '';
    @Input() public role: string = 'button';
    @Input() public disabled: boolean = false;
    @Input() public loading: OLO.Components.LOADING_STATUS = null;
    @Input() public width: OLO.Components.BUTTON_WIDTH = 'extended';
    @Input() public paddings: boolean = true;
    @Input() public type: string = 'submit';
    @Input() public align: 'left' | 'right' | 'center' = 'left';
    @Input() public marginTop: OLO.Components.MARGIN_SIZE = 'md';
    @Input() public marginBottom: OLO.Components.MARGIN_SIZE = null;
    @Input() public offsetLeft: boolean = false;
    @Input() public offsetRight: boolean = false;

    @ViewChild('btn', { static: false, read: ElementRef }) public btn: ElementRef;

    @Output() public onClick: EventEmitter<Event> = new EventEmitter();

    constructor() { }

    ngOnInit(): void {
        if (this.btn && this.btn.nativeElement) {
            this.title = (this.btn.nativeElement as HTMLElement).innerText;
        }
    }

    public handleClick($event: Event): void {
        this.onClick.emit($event);
    }
}
